function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Tag as AntdTag } from 'antd';
import useStyles from "./style";
export default function Tag(props) {
  var _useStyles = useStyles(),
    prefixCls = _useStyles.prefixCls,
    cx = _useStyles.cx,
    styles = _useStyles.styles;
  return /*#__PURE__*/React.createElement(AntdTag, _extends({}, props, {
    className: cx(props.className, styles[prefixCls + '-aelfd-tag'])
  }));
}